// extracted by mini-css-extract-plugin
export default {"overlay":"Dialog__overlay__qXgA1","open":"Dialog__open__z4cbA","close":"Dialog__close__lTM5_","container":"Dialog__container__VfbCm","header":"Dialog__header__GrJ6w","footer":"Dialog__footer__y5jbN","stickyTop":"Dialog__stickyTop__b6iHK","stickyBottom":"Dialog__stickyBottom__k_MA0","blockOf24":"Dialog__blockOf24__oFQ5M","marginLeft8":"Dialog__marginLeft8__w8vHd","lineClamp1":"Dialog__lineClamp1___oLAh"};
    if(module.hot) {
      // 1753686713744
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  